export default "__VITE_ASSET__nYXhLPQt__"